import React, { useMemo } from 'react';
import { OverwriteUwRatesContent } from 'components/overwrite-uw-rates';
import { OverrideUwRatesPageStore, OverrideUwRatesPageStoreContext } from 'store/pages/override-uw-rates/pageStore';
import { useParams } from 'react-router-dom';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { NarrowPageWrapperStyled } from '../../globalStyles';

const OverrideUwRatesPage: React.FC = () => {
  const { periodId, cartId, portfolioId, productLineId } = useParams<{
    periodId: string;
    cartId: string;
    portfolioId: string;
    productLineId: ProductLineId;
  }>();

  const pageStore = useMemo(
    () =>
      new OverrideUwRatesPageStore({
        periodId,
        cartId,
        portfolioId: decodeURIComponent(portfolioId),
        productLineId,
      }),
    [periodId, cartId, portfolioId, productLineId],
  );

  return (
    <NarrowPageWrapperStyled>
      <OverrideUwRatesPageStoreContext.Provider value={pageStore}>
        <OverwriteUwRatesContent />
      </OverrideUwRatesPageStoreContext.Provider>
    </NarrowPageWrapperStyled>
  );
};

export default OverrideUwRatesPage;
